import { css } from '@compiled/react';
import { UniformRichTextNode } from '@uniformdev/canvas-react';
import { ParameterRichTextValue, RichTextNode } from '@uniformdev/richtext';

import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';

import { Button } from '@/libraries/design/components/button/src/button';
import { ContentBlock } from '@/libraries/design/components/content-block/src/content-block';
import { ColumnLayout, wacToken } from '@/libraries/design/foundations';

import { AmbientShimmerGraph } from './ambient-shimmer-graph';
export interface UniformHoveringTeamworkGraphProps {
	heading: string;
	bodyText: ParameterRichTextValue;
	ctaLabel: string;
	ctaUrl: string;
}

const UniformHoveringTeamworkGraph = ({
	heading,
	bodyText,
	ctaLabel,
	ctaUrl,
}: UniformHoveringTeamworkGraphProps) => {
	return (
		<div
			className="hovering-teamwork-graph"
			css={css({
				backgroundColor: wacToken('color.neutral.light1100'),
				paddingBlock: token('space.1000'),
				position: 'relative',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
			})}
		>
			<div
				css={css({
					position: 'relative',
					width: '100%',
					zIndex: 9,
				})}
			>
				<ColumnLayout layout="12">
					<div css={css({ position: 'relative', width: '100%' })}>
						<div
							css={css({
								width: '38%',
								position: 'absolute',
								[media.below.md]: {
									width: 'auto',
									position: 'relative',
								},
							})}
						>
							<ContentBlock
								title={heading}
								titleAs="h2"
								text={<UniformRichTextNode node={bodyText.root as RichTextNode} />}
								backgroundColor={wacToken('color.neutral.light1100')}
							/>
							<Button
								variant={'secondary'}
								responsiveSize={{
									mobile: 'small',
									tablet: 'small',
									desktop: 'large',
									xl_desktop: 'large',
								}}
								colorAgainst={'black'}
								href={ctaUrl}
								aria-label={`${ctaLabel}, ${heading}`}
								dataEventProps={{
									'data-product-key': 'uniform',
									'data-event': 'clicked',
									'data-event-component': 'linkButton',
									'data-event-container': 'bodyContentInline',
									'data-label': ctaLabel,
									'data-label-english': ctaLabel,
								}}
							>
								{ctaLabel}
							</Button>
						</div>
					</div>
				</ColumnLayout>
			</div>

			<AmbientShimmerGraph />
		</div>
	);
};

export default UniformHoveringTeamworkGraph;
